/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum IntegrationConnectionHealthStatus {
    HEALTHY = 'healthy',
    PAUSED = 'paused',
    SYNCING = 'syncing',
    ERROR = 'error',
}
